module.exports = {
    recorridoData: () => {
        return [
            {
                "START": {
                    "Image": require('./../assets/recorridoParticulares/General_01.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-14.636 -0.129 -1.013",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        }
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.170 -0.129 4.367",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"3.879 -0.129 3.144",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"4.780 -0.129 -1.644",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20S"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "GENERAL 2": {
                    "Image": require('./../assets/recorridoParticulares/General_02.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-7.076 -0.129 -7.573",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                        {
                            "Position":"-12.480 -0.129 -2.519",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"11.962 -0.129 1.712",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-8.177 -0.129 -4.069",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"7.392 -0.129 4.378",
                            "Rotation":"-90 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "GENERAL 3": {
                    "Image": require('./../assets/recorridoParticulares/General_03.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-5.377 -0.129 -3.255",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                        {
                            "Position":"-4.663 -0.129 4.750",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"2.417 -0.129 -4.501",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                        {
                            "Position":"8.646 -0.129 -13.633",
                            "Rotation":"-83.986 -32.826 59.875",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                    ],
                    "HotspotIndividual": [
                    ],
                    "BulletsInfo":[
                    ]
                },

                "FAMILIA KONA": {
                    "Image": require('./../assets/recorridoParticulares/KonaFamilia.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"3.441 -0.129 6.422",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"3.441 -0.129 1.648",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"3.441 -0.129 -10.564",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-3.098 -0.129 3.591",
                            "Rotation":"-90 10 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM"
                        },
                        {
                            "Position":"-1.855 -0.129 -2.725",
                            "Rotation":"-90 10 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "FAMILIA TUCSON": {
                    "Image": require('./../assets/recorridoParticulares/TucsonFamilia.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"5.747 -0.129 -4.761",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.368 -0.129 0.094",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"10.159 -0.129 5.743",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-3.170 -0.129 -5.288",
                            "Rotation":"-90 10 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED"
                        },
                        {
                            "Position":"-3.522 -0.129 -0.271",
                            "Rotation":"-90 10 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"-1.162 -0.129 3.811",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },

                "NUEVO HB20": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"2.354 -0.129 1.376",
                            "Rotation":"-90 10 0",
                            "Scale":"0.3 0.3",
                            "goTo":"START"
                        },
                        {
                            "Position":"7.796 -0.129 -5.338",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -2.614",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.036",
                            "Rotation":"-95 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 LAT DER"
                        },
                        {
                            "Position":"1.811 -0.129 3.999",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20S"
                        },
                        {
                            "Position":"4.044 -0.129 -6.587",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.801 0.037",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez."],
                            "Image": require("./../UI/Bullets/NuevaHB20/parrilla.webp")
                        },
                        {
                            "Position":"-3.826 -0.614 0.037",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["El motor Gamma 1.6, tiene una potencia de 121,3 Hp y un torque de 152 Nm. Las modernas tecnologías DOHC y D-CVVT producen una excelente potencia con un protocolo de emisiones de bajo consumo para Euro 5."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/motor.webp")
                        }
                    ]
                },
                "NUEVO HB20 DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-1.033 -0.129 4.016",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"10.381 -0.129 2.669",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 LAT IZQ"
                        },
                        {
                            "Position":"-3.126 -0.129 6.121",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20S"
                        },
                        {
                            "Position":"4.963 -0.129 0.262",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.600 0.894",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez."],
                            "Image": require("./../UI/Bullets/NuevaHB20/parrilla.webp")
                        },
                        {
                            "Position":"-3.826 -0.678 -0.592",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.851 -1.177",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.698 -1.665",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20 LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-5.147 -0.129 6.391",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"2.627 -0.129 11.706",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 POSTERIOR"
                        },
                        {
                            "Position":"3.447 -0.129 8.174",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"-7.485 -0.129 5.364",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 2.291",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.747 1.237",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.300 -0.214",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20 LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-1.901 -0.129 -7.172",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-8.337 -0.129 -10.469",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 3.743",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20 POSTERIOR"
                        },
                        {
                            "Position":"-8.725 -0.129 -7.130",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"1.182 -0.129 -5.691",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 -2.291",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.747 -1.237",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.300 0.214",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20 DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-9.167 -0.129 -6.647",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 LAT DER"
                        },
                        {
                            "Position":"-4.881 -0.129 -7.838",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "NUEVO HB20 POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/HB20Advance-RinBitono_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.642 -0.129 -1.354",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 2.223",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -2.135",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20 LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 0.171",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Amplio baúl con capacidad de 300 L y bandeja cubre equipaje."],
                            "Image": require("./../UI/Bullets/NuevaHB20/baul.webp")
                        },
                        {
                            "Position":"-3.826 0.747 0.180",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La vista trasera del Nuevo HB20 está completamente renovada, revolucionando el diseño de las luces integradas. La armonía entre el nuevo parachoques con elementos en negro mate, las luces de marcha atrás colocados en los parachoques y la tapa del maletero más grande hacen que el aspecto sea aún más tecnológico y moderno."],
                            "Image": require("./../UI/Bullets/NuevaHB20/posterior.webp")
                        },
                    ]
                },

                "NUEVO HB20S": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.735 -0.129 1.063",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"13.306 -0.129 3.307",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        }
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -2.614",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.036",
                            "Rotation":"-95 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S LAT DER"
                        },
                        {
                            "Position":"2.485 -0.129 -3.786",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"11.242 -0.129 -1.655",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.801 0.037",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/parrilla.webp")
                        },
                        {
                            "Position":"-3.826 -0.614 0.037",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["El motor Gamma 1.6, tiene una potencia de 121,3 Hp y un torque de 152 Nm. Las modernas tecnologías DOHC y D-CVVT producen una excelente potencia con un protocolo de emisiones de bajo consumo para Euro 5."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/motor.webp")
                        }
                    ]
                },
                "NUEVO HB20S DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"9.016 -0.129 8.131",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA HB20S"
                        }
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"0.273 -0.129 4.032",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"5.807 -0.129 11.894",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S LAT IZQ"
                        },
                        {
                            "Position":"2.924 -0.129 0.701",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"7.744 -0.129 8.511",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"STARIA PASAJEROS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.600 0.894",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/parrilla.webp")
                        },
                        {
                            "Position":"-3.826 -0.678 -0.592",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20S/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.851 -1.177",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.698 -1.665",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20S LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-2.954 -0.129 7.358",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-5.501 -0.129 14.428",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S POSTERIOR"
                        },
                        {
                            "Position":"0.831 -0.129 6.576",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-1.893 -0.129 14.219",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 2.291",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20S/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.747 1.237",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.300 -0.214",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20S/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20S LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-1.992 -0.129 -6.865",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"0.155 -0.129 -16.339",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        }
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 3.743",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S POSTERIOR"
                        },
                        {
                            "Position":"-7.598 -0.129 -6.677",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-4.543 -0.129 -13.962",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 -2.570",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Rin de 15 pulgadas en aleación bitono"],
                            "Image": require("./../UI/Bullets/NuevaHB20S/Rin.webp")
                        },
                        {
                            "Position":"-3.826 0.747 -1.509",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos eléctricos color de la carrocería con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/retrovisor.webp")
                        },
                        {
                            "Position":"-3.826 0.300 -0.086",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Llave de comando a distancia con desbloqueo de la puerta del baúl"],
                            //"Image": require("./../UI/Bullets/NuevaHB20S/baul.webp")
                        }
                    ]
                },
                "NUEVO HB20S DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-8.426 -0.129 -6.238",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S LAT DER"
                        },
                    ],
                    "BulletsInfo":[
                    ]
                },
                "NUEVO HB20S POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/HB20SAdvance-RinBitono_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.642 -0.129 -1.354",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 2.223",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -2.770",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20S LAT DER"
                        },
                        {
                            "Position":"-10.100 -0.129 4.320",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"NUEVO HB20"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.678 -0.088",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Amplio baúl con capacidad de 300 L y bandeja cubre equipaje."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/baul.webp")
                        },
                        {
                            "Position":"-3.826 0.747 -0.089",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["La vista trasera del Nuevo HB20 está completamente renovada, revolucionando el diseño de las luces integradas. La armonía entre el nuevo parachoques con elementos en negro mate, las luces de marcha atrás colocados en los parachoques y la tapa del maletero más grande hacen que el aspecto sea aún más tecnológico y moderno."],
                            "Image": require("./../UI/Bullets/NuevaHB20S/posterior.webp")
                        },
                    ]
                },

                "STARIA PASAJEROS": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"4.564 -0.129 -19.123",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                        {
                            "Position":"10.866 -0.129 -12.846",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"2.701 -0.129 4.843",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"2.701 -0.129 -2.531",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                        {
                            "Position":"6.611 -0.129 -13.060",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -4.019",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS LAT IZQ"
                        },
                        {
                            "Position":"-4.304 -0.129 3.579",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS LAT DER"
                        },
                        {
                            "Position":"0.600 -0.129 6.952",
                            "Rotation":"-90 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"5.067 -0.129 8.093",
                            "Rotation":"-90 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.264 -2.358",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Luces frontales halógenas + DRL"],
                        },
                        {
                            "Position":"-5.002 0.742 -0.035",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["• Motor 2.2 L CRDI Diesel", "• Transmisión mecánica de 6 velocidades.", "• Motor 2,2 VGT (Turbo de Geometría Variable)", "• Potencia máxima 177 HP / 3800 rpm", "• Torque máximo 44 Kgm / 1500 ~ 2500 rpm"],
                        }
                    ]
                },
                "STARIA PASAJEROS DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"14.761 -0.129 -7.792",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                        {
                            "Position":"14.761 -0.129 0.246",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-4.506 -0.129 7.456",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"12.779 -0.129 -3.923",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"5.257 -0.129 1.522",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS LAT IZQ"
                        },
                        {
                            "Position":"-7.162 -0.129 8.379",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"-3.885 -0.129 11.513",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.226 0.181 -0.443",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["• ABS (sistema antibloqueo de frenos).", "• ESC (control electrónico de estabilidad).", "• HAC (Hill assistant control para ascenso y descenso)." ,"• TCS (Sistema de control de tracción)."],
                        },
                        {
                            "Position":"-2.976 1.640 -0.872",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos exteriores eléctricos + calefacción."],
                        },
                    ]
                },
                "STARIA PASAJEROS LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[

                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"6.282 -0.129 8.226",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"-0.864 -0.129 7.039",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 6.080",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.175 2.661",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["• ABS (sistema antibloqueo de frenos).", "• ESC (control electrónico de estabilidad).", "• HAC (Hill assistant control para ascenso y descenso)." ,"• TCS (Sistema de control de tracción)."],
                        },
                        {
                            "Position":"-2.913 1.297 0.797",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Vidrios eléctricos con un toque de bajada en el vidrio del conductor'],
                        },
                        {
                            "Position":"-3.276 1.473 1.701",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos exteriores eléctricos + calefacción."],
                        }
                    ]
                },
                "STARIA PASAJEROS LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-5.620 -0.129 -7.586",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                        {
                            "Position":"1.342 -0.129 -7.586",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -4.938",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"STARIA PASAJEROS POSTERIOR"
                        },
                        {
                            "Position":"4.182 -0.129 -5.708",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20"
                        },
                        {
                            "Position":"4.9888 -0.129 -9.540",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"NUEVO HB20S"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.021 -3.281",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Llantas de acero de 17"'],
                        },
                        {
                            "Position":"-5.136 1.141 -1.781",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Vidrios eléctricos con un toque de bajada en el vidrio del conductor'],
                        },
                        {
                            "Position":"-3.073 1.644 -1.699",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos exteriores eléctricos + calefacción."],
                        }
                    ]
                },
                "STARIA PASAJEROS DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-6.612 -0.129 -9.938",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.181 -0.667",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Llantas de acero de 17"'],
                        }
                    
                    ]
                },
                "STARIA PASAJEROS POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/StariaServicioPublico_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 3.785",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -4.288",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"STARIA PASAJEROS LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.674 0.019",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Camioneta de 2 plazas (2 personas) con espacio de carga = 4.935l.'],
                        },
                        {
                            "Position":"-3.826 1.712 -1.013",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Puertas batientes gemelas (Únicamente versión Staria Panel).'],
                        }
                    ]
                },

                "KONA LIMITED": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"6.814 -0.129 7.248",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.322 -0.129 2.079",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"4.322 -0.129 -7.180",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -2.849",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.036",
                            "Rotation":"-95 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED LAT DER"
                        },
                        {
                            "Position":"0.946 -0.129 6.186",
                            "Rotation":"-95 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -1.384",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Luces de posicionamiento LED y DRL LED.'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_LUCES DELAN.webp")
                        },
                        {
                            "Position":"-3.826 0.030 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Motor a gasolina: Cilindraje 1.580.', '• Numero de cilindros: 4 (en línea)','• potencia máxima: (HP/ RPM): 103,5/5700', '• Torque máximo (KG-m/ RPM): 15/4000', '• Motor eléctrico: potencia máxima (HP): 43', '• Torque máximo (Kg-m): 17.3'],
                        },
                    ]
                },
                "KONA LIMITED DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-1.385 -0.129 11.901",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-2.800 -0.129 7.709",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"7.131 -0.129 -0.680",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-5.143 -0.129 6.354",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.643 -0.584",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin de aluminio bitono de 18“'],
                            "Image": require("./../UI/Bullets/06_Kona - Limited/KonaLimited_RIN 18 ALUMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.375 -1.518",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139', '• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA LIMITED LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-9.523 -0.129 10.201",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.058 -0.129 6.475",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 2.369",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin de aluminio bitono de 18“'],
                            "Image": require("./../UI/Bullets/06_Kona - Limited/KonaLimited_RIN 18 ALUMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.030 -0.519",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139','• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA LIMITED LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"3.566 -0.129 -9.894",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"0.639 -0.129 -7.098",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED POSTERIOR"
                        },
                        {
                            "Position":"3.156 -0.129 -4.226",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -2.707",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin de aluminio bitono de 18“'],
                            "Image": require("./../UI/Bullets/06_Kona - Limited/KonaLimited_RIN 18 ALUMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.030 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139', '• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA LIMITED DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-5.221 -0.129 -11.912",
                            "Rotation":"-90 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-6.895 -0.129 -7.362",
                            "Rotation":"-90 0 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED LAT DER"
                        },
                        {
                            "Position":"-2.467 -0.129 -8.685",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"KONA PREMIUM"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -0.798",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin de aluminio bitono de 18“'],
                            "Image": require("./../UI/Bullets/06_Kona - Limited/KonaLimited_RIN 18 ALUMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.375 -1.562",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['•Potencia y torque combinados: Potencia combinada (HP) 139' ,'• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA LIMITED POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/KonaLimited_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 2.745",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -2.900",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.375 -1.518",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Luces LED traseras combinadas'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_LUCES-LED-TRA.webp")
                        },
                        {
                            "Position":"-3.826 -1.040 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Bateria polimero de iones de litio.', '• Capacidad (kWh): 1.56.', '• Voltaje (V): 240.'],
                        }
                    ]
                },

                "KONA PREMIUM": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"4.841 -0.129 2.781",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.841 -0.129 -0.386",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -2.849",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.036",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM LAT DER"
                        },
                        {
                            "Position":"1.493 -0.129 -5.857",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -1.384",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Luces de posicionamiento LED y DRL LED.'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_LUCES DELAN.webp")
                        },
                        {
                            "Position":"-3.826 0.030 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Motor a gasolina: Cilindraje 1.580.', '• Numero de cilindros: 4 (en línea).' ,'• potencia máxima: (HP/ RPM): 103,5/5700.','• Torque máximo (KG-m/ RPM): 15/4000.', '• Motor eléctrico: potencia máxima (HP): 43.', '• Torqué máximo (Kg-m): 17.3.'],
                        },
                        {
                            "Position":"-3.826 -1.548 0.112",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['La parte delantera esculpida con una nueva forma de diseño proyecta un aspecto deportivo.'],
                        },
                    ]
                },
                "KONA PREMIUM DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-0.614 -0.129 8.701",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"1.453 -0.129 3.732",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"4.448 -0.129 -1.594",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.643 -0.584",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin bitono de aluminio 16"'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_RIN 16 ALIMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.375 -1.518",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139', '• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA PREMIUM LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-6.710 -0.129 9.049",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-1.845 -0.129 9.158",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM POSTERIOR"
                        },
                        {
                            "Position":"2.851 -0.129 6.029",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 2.369",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin bitono de aluminio 16"'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_RIN 16 ALIMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.030 -0.519",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139.', '• Torque combinado (Kgm) 17,3.'],
                        }
                    ]
                },
                "KONA PREMIUM LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"1.400 -0.129 -8.290",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-3.383 -0.129 -8.290",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -4.408",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"KONA PREMIUM POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -2.707",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin bitono de aluminio 16"'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_RIN 16 ALIMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.030 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139.', '• Torque combinado (Kgm) 17,3.'],
                        }
                    ]
                },
                "KONA PREMIUM DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-7.064 -0.129 -9.955",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA TUCSON"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-8.610 -0.129 -6.956",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.524 -0.798",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['"• ABS (sistema antibloqueo de frenos).", "• ESC (control electrónico de estabilidad).", "• HAC (Hill assistant control para ascenso y descenso)." ,"• TCS (Sistema de control de tracción)."'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_RIN 16 ALIMINIO BITONO.webp")
                        },
                        {
                            "Position":"-3.826 0.375 -1.562",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Potencia y torque combinados: Potencia combinada (HP) 139' , '• Torque combinado (Kgm) 17,3'],
                        }
                    ]
                },
                "KONA PREMIUM POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/KonaPremium_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 2.745",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -2.900",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"KONA PREMIUM LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.375 -1.518",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Luces LED traseras combinadas'],
                            "Image": require("./../UI/Bullets/06_Kona - Premium/KonaPremium_LUCES-LED-TRA.webp")
                        },
                        {
                            "Position":"-3.826 -1.040 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Bateria polimero de iones de litio.' , '• Capacidad (kWh): 1.56. Voltaje (V): 240.'],
                        }
                    ]
                },

                "TUCSON NX4 ATTRACTION": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"10.763 -0.129 -2.244",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.841 -0.129 0.963",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"6.703 -0.129 8.209",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -3.655",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.828",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION LAT DER"
                        },
                        {
                            "Position":"1.853 -0.129 -4.071",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"4.587 -0.129 -7.954",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "TUCSON NX4 ATTRACTION DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"7.633 -0.129 7.420",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"1.718 -0.129 5.895",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION LAT IZQ"
                        },
                        {
                            "Position":"3.609 -0.129 -0.824",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"8.602 -0.129 -0.301",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "TUCSON NX4 ATTRACTION LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-0.653 -0.129 12.771",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-3.948 -0.129 8.645",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 5.594",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION POSTERIOR"
                        },
                        {
                            "Position":"1.794 -0.129 5.971",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "TUCSON NX4 ATTRACTION LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-4.823 -0.129 -14.059",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-2.188 -0.129 -8.425",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -5.096",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "TUCSON NX4 ATTRACTION DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-7.355 -0.129 -8.240",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        
                    ]
                },
                "TUCSON NX4 ATTRACTION POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Atracttion_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        
                    ]
                },

                "TUCSON NX4 PREMIUM": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"6.859 -0.129 -3.339",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.841 -0.129 -0.169",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                        {
                            "Position":"12.131 -0.129 5.850",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 2"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -3.655",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.828",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM LAT DER"
                        },
                        {
                            "Position":"1.439 -0.129 5.140",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"0.889 -0.129 -4.671",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.233 -2.151",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Faros de proyección."],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_FAROS DE PROYECCIÓN 2.webp")
                        },
                        {
                            "Position":"-3.826 1.143 -1.409",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos exteriores con ajuste y plegado eléctrico con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_ESPEJOS ELECTRICOS.webp")
                        },
                        {
                            "Position":"-3.826 -1.521 -0.039",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Parrilla frontal con luz LED envolvente (DRL+ Posicionamiento)."],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_PARRILLA FRONTAL PARAMETRICA.webp")
                        },
                        {
                            "Position":"-3.826 -0.124 -0.037",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Motor Smartstream 2.0L Gasolina corriente"],
                        }
                    ]
                },
                "TUCSON NX4 PREMIUM DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"6.487 -0.129 5.333",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"1.718 -0.129 4.563",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"-4.053 -0.129 5.333",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"2.329 -0.129 -0.789",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.456 0.322 3.826",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Faros de proyección."],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_FAROS DE PROYECCIÓN 2.webp")
                        },
                        {
                            "Position":"-3.826 1.143 -1.409",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Espejos exteriores con ajuste y plegado eléctrico con direccionales incorporadas."],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_ESPEJOS ELECTRICOS.webp")
                        },
                        {
                            "Position":"-3.826 -0.396 -0.690",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin 18" Aluminio Bitono.'],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_RIN BITONO.webp")
                        },
                    ]
                },
                "TUCSON NX4 PREMIUM LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-0.653 -0.129 12.771",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-3.948 -0.129 8.645",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 5.594",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM POSTERIOR"
                        },
                        {
                            "Position":"1.794 -0.129 5.971",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.396 2.702",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin 18" Aluminio Bitono.'],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_RIN BITONO.webp")
                        },
                    ]
                },
                "TUCSON NX4 PREMIUM LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-7.248 -0.129 -12.963",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-2.188 -0.129 -8.425",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -5.096",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM POSTERIOR"
                        },
                        {
                            "Position":"1.495 -0.129 -6.313",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.396 -2.702",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin 18" Aluminio Bitono.'],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_RIN BITONO.webp")
                        },
                    ]
                },
                "TUCSON NX4 PREMIUM DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-7.355 -0.129 -8.240",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM LAT DER"
                        },
                        {
                            "Position":"-4.694 -0.129 -8.240",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.396 -0.984",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Rin 18" Aluminio Bitono.'],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_RIN BITONO.webp")
                        },
                    ]
                },
                "TUCSON NX4 PREMIUM POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Premium_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.706 0.015",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['• Logotipo tridimensional no sobresaliente, incorporado en el vidrio panorámico trasero.'],
                            "Image": require("./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_LOGO 3D Y PARABRISAS TRASERO.webp")
                        },
                        {
                            "Position":"-3.826 1.572 1.113",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['El limpiaparabrisas oculto dentro del amplio alerón trasero.'],
                        },
                        {
                            "Position":"-3.826 0.030 0.119",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Cámara de reversa con dos vistas y con guías dinámicas.'],
                        },
                        {
                            "Position":"-3.826 1.149 -1.446",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":['Vidrios de privacidad traseros.'],
                        },
                    ]
                },

                "TUCSON NX4 LIMITED": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_Frente.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"7.495 -0.129 -2.681",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"4.841 -0.129 2.781",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        }
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.682 -0.129 -1.656",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED DIG IZQ"
                        },
                        {
                            "Position":"-5.384 -0.129 -3.655",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-5.374 -0.129 3.828",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED LAT DER"
                        },
                        {
                            "Position":"5.271 -0.129 7.516",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"1.918 -0.129 4.398",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "TUCSON NX4 LIMITED DIG IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_DiagonalIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"6.487 -0.129 5.333",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"0.797 -0.129 7.463",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.122 -0.129 1.417",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED"
                        },
                        {
                            "Position":"-3.394 -0.129 -2.392",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-2.901 -0.129 11.250",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 ATTRACTION"
                        },
                        {
                            "Position":"-3.620 -0.129 6.210",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "TUCSON NX4 LIMITED LAT IZQ": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_LateralIzq.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-0.653 -0.129 12.771",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-3.948 -0.129 8.645",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 5.594",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED DIG IZQ"
                        },
                        {
                            "Position":"-3.708 -0.129 -4.554",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "TUCSON NX4 LIMITED LAT DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_LateralDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                        {
                            "Position":"-5.531 -0.129 -9.766",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA KONA"
                        },
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-2.188 -0.129 -8.425",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-4.148 -0.129 -5.096",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED"
                        },
                        {
                            "Position":"-1.668 -0.129 2.441",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED DIG DER"
                        },
                        {
                            "Position":"-3.708 -0.129 4.729",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 LIMITED POSTERIOR"
                        },
                        {
                            "Position":"0.342 -0.129 -7.291",
                            "Rotation":"-90 0 0",
                            "Scale":"0.4 0.4",
                            "goTo":"TUCSON NX4 PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "TUCSON NX4 LIMITED DIG DER": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_DiagonalDer.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                        {
                            "Position":"-9.199 -0.129 -8.240",
                            "Rotation":"-90 10 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL 3"
                        },
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-2.301 -0.129 1.198",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED POSTERIOR"
                        },
                        {
                            "Position":"-3.459 -0.129 -2.150",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED LAT DER"
                        },
                        {
                            "Position":"-5.479 -0.129 -8.240",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 PREMIUM"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
                "TUCSON NX4 LIMITED POSTERIOR": {
                    "Image": require('./../assets/recorridoParticulares/TucsonNX4Limited_Posterior.webp'),
                    "Rotation":"0 90 0",
                    "HotspotFamilias":[
                    ],
                    "HotspotDesplazamiento":[
                    ],
                    "HotspotIndividual": [
                        {
                            "Position":"-1.017 -0.129 -1.598",
                            "Rotation":"-90.000 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED DIG DER"
                        },
                        {
                            "Position":"-4.239 -0.129 3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED LAT IZQ"
                        },
                        {
                            "Position":"-4.239 -0.129 -3.351",
                            "Rotation":"-90 0 0",
                            "Scale":"0.3 0.3",
                            "goTo":"TUCSON NX4 LIMITED LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                    ]
                },
            }
        ]
    }
}